var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M37.058 54.622c.276.977 1.294 1.55 2.248 1.209a26.698 26.698 0 10-18.886-.333c.942.376 1.98-.162 2.29-1.128.31-.966-.226-1.993-1.164-2.379a23.024 23.024 0 1116.759.295c-.951.352-1.523 1.36-1.247 2.336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52.193 19.235c.972-.51 1.354-1.714.774-2.646a26.697 26.697 0 10-32.504 38.926c1.02.405 2.138-.186 2.465-1.233.328-1.047-.26-2.154-1.275-2.572a22.722 22.722 0 01-8.793-35.577 22.723 22.723 0 0136.576 2.306c.592.924 1.785 1.305 2.757.796z"
  })));
}
export default SvgProgress3;